module.exports = __webpack_public_path__ + "img/134ne.d531ee77.svg";